import React from 'react';

// Styles & Assets
import styles from './ButtonAdd.module.css';
import { IoMdAdd } from 'react-icons/io';

// Other
import { Link } from 'react-router-dom';

const ButtonAdd: React.FC<{
    link?: string,
    text: string,
    reveredColors?: boolean
    handleClick?: () => void
}> = ({ link, text, reveredColors, handleClick }) => {

    const reversedColorsClass = reveredColors ? styles.reversedColors : '';

    return (
        <> { link === undefined ? 
            <button 
                className={`button ${styles.buttonAddScore} ${reversedColorsClass}`}
                onClick={handleClick}
            >
                {text}
                <IoMdAdd />
            </button>
            :
            <Link to={link} className={`anchorButton ${styles.buttonAddScore} ${reversedColorsClass}`}>
                {text}
                <IoMdAdd />
            </Link>
        } </>
    );
};

export default ButtonAdd;